import React, { useState } from "react";
import { IoEyeOffOutline, IoLinkOutline, IoDownloadOutline, IoMailOutline, IoCallOutline, IoImageOutline } from "react-icons/io5";
import { formatDateDMY } from "../../helper/helperFunctions";

export default function AdTable({ ads, size, onDelete, loading }) {
    const [imageErrors, setImageErrors] = useState({});

    const renderPriorityBadge = (level) => {
        switch (level) {
            case 1: return <span className="am-prio-badge lvl1">⭐ L1</span>;
            case 2: return <span className="am-prio-badge lvl2">🔥 L2</span>;
            case 3: return <span className="am-prio-badge lvl3">👑 L3</span>;
            default: return <span className="am-prio-badge lvl0">Std</span>;
        }
    };

    const handleImageError = (id) => {
        setImageErrors((prev) => ({ ...prev, [id]: true }));
    };

    // კონკრეტული რეკლამის ოფიციალური ქართული PDF-ის გენერირება
    const downloadAdPDF = (ad) => {
        const printWindow = window.open("", "_blank");

        const sizeTranslations = { small: "მცირე (Small 150x150)", medium: "საშუალო (Medium 400x150)", big: "დიდი (Big 1000x200)" };
        const prioTranslations = { 0: "სტანდარტული (დონე 0)", 1: "პრიორიტეტული (დონე 1)", 2: "ჩაკეტილი 100% (დონე 2)", 3: "მონოპოლია (დონე 3)" };

        printWindow.document.write(`
            <html lang="ka">
            <head>
                <title>სარეკლამო შეთანხმება - TEACHER HUB</title>
                <style>
                    body { font-family: 'Segoe UI', sans-serif; padding: 40px; color: #1e293b; line-height: 1.6; }
                    .header { display: flex; justify-content: space-between; align-items: center; border-bottom: 2px solid #4f46e5; padding-bottom: 20px; margin-bottom: 30px; }
                    .logo { font-size: 26px; font-weight: 800; color: #4f46e5; text-decoration: none; }
                    .doc-title { text-align: center; text-transform: uppercase; margin: 30px 0; font-size: 18px; font-weight: 700; color: #0f172a; letter-spacing: 0.5px; }
                    
                    .parties-container { display: flex; justify-content: space-between; gap: 40px; margin-bottom: 30px; }
                    .party-box { flex: 1; border: 1px solid #e2e8f0; padding: 16px; border-radius: 8px; background-color: #f8fafc; }
                    .party-title { font-weight: 700; font-size: 14px; color: #4f46e5; border-bottom: 1px solid #cbd5e1; padding-bottom: 6px; margin-bottom: 10px; text-transform: uppercase; }
                    .party-row { font-size: 13px; margin: 4px 0; }
                    .party-row strong { color: #475569; }

                    .section-title { font-size: 14px; font-weight: 700; color: #0f172a; margin-top: 30px; margin-bottom: 10px; border-bottom: 1px solid #e2e8f0; padding-bottom: 4px; }
                    
                    .grid-details { display: grid; grid-template-columns: 1fr 1fr; gap: 15px; margin-bottom: 20px; }
                    .detail-card { border: 1px solid #e2e8f0; padding: 12px; border-radius: 6px; background: #fff; }
                    .detail-card span { display: block; font-size: 11px; color: #64748b; text-transform: uppercase; font-weight: 600; }
                    .detail-card p { margin: 4px 0 0 0; font-size: 14px; font-weight: 600; color: #0f172a; }
                    .db-id-badge { display: inline-block; background-color: #f1f5f9; padding: 2px 8px; border-radius: 4px; font-family: monospace; font-size: 13px; font-weight: 700; color: #4f46e5; border: 1px solid #cbd5e1; margin-left: 5px; }

                    .invoice-summary { background: #eef2ff; border: 1px solid #c7d2fe; border-radius: 8px; padding: 15px 20px; display: flex; justify-content: space-between; align-items: center; margin: 25px 0; }
                    .invoice-label { font-weight: 700; color: #3730a3; font-size: 14px; }
                    .invoice-price { font-size: 22px; font-weight: 800; color: #4f46e5; }

                    .terms-section { font-size: 12px; border: 1px solid #e2e8f0; padding: 15px; border-radius: 8px; background-color: #f8fafc; color: #475569; }
                    .terms-title { font-weight: 700; margin-bottom: 6px; color: #0f172a; }

                    .signatures { display: flex; justify-content: space-between; margin-top: 60px; align-items: flex-start; }
                    .sig-block { display: flex; flex-direction: column; align-items: center; width: 250px; }
                    .sig-line { border-top: 1px solid #475569; width: 100%; text-align: center; padding-top: 8px; font-size: 12px; font-weight: 600; color: #475569; }
                    
                    .digital-stamp {
                        border: 2px dashed #4f46e5;
                        background: #f5f3ff;
                        color: #4f46e5;
                        padding: 8px 12px;
                        border-radius: 6px;
                        font-family: 'Courier New', monospace;
                        font-size: 10px;
                        font-weight: bold;
                        text-align: center;
                        margin-bottom: 8px;
                        line-height: 1.4;
                    }
                    .footer { margin-top: 50px; font-size: 11px; color: #64748b; border-top: 1px solid #e2e8f0; padding-top: 15px; text-align: center; }
                </style>
            </head>
            <body>
                <div class="header">
                    <a href="https://www.teacherhub.ge" class="logo">TEACHER HUB</a>
                    <div style="font-size: 13px; color: #64748b;">თარიღი: ${new Date().toLocaleDateString('ka-GE')}</div>
                </div>

                <div class="doc-title">სარეკლამო მომსახურების ხელშეკრულების დეტალები</div>

                <div class="parties-container">
                    <div class="party-box">
                        <div class="party-title">მომწოდებელი</div>
                        <div class="party-row"><strong>კომპანია:</strong> Teacher Hub Georgia</div>
                        <div class="party-row"><strong>ვებ-გვერდი:</strong> www.teacherhub.ge</div>
                        <div class="party-row"><strong>სტატუსი:</strong> სარეკლამო პლატფორმა</div>
                    </div>
                    <div class="party-box">
                        <div class="party-title">დამკვეთი</div>
                        <div class="party-row"><strong>სახელი, გვარი:</strong> ${ad.fullname || "N/A"}</div>
                        <div class="party-row"><strong>პირადი ნომერი:</strong> ${ad.person_id || "N/A"}</div>
                        <div class="party-row"><strong>მობილური:</strong> ${ad.phone || "N/A"}</div>
                        <div class="party-row"><strong>ელ-ფოსტა:</strong> ${ad.email || "N/A"}</div>
                    </div>
                </div>

                <div class="section-title">სარეკლამო კამპანიის პარამეტრები</div>
                <div class="grid-details">
                    <div class="detail-card">
                        <span>ჩანაწერის უნიკალური ID</span>
                        <p style="display: flex; align-items: center;">სისტემური გასაღები: <span class="db-id-badge">#${ad.id}</span></p>
                    </div>
                    <div class="detail-card">
                        <span>ბანერის ზომა და ტიპი</span>
                        <p>${sizeTranslations[size] || size}</p>
                    </div>
                    <div class="detail-card">
                        <span>კამპანიის დაწყება</span>
                        <p>${formatDateDMY(ad.started_at)}</p> </div>
                    <div class="detail-card">
                        <span>კამპანიის დასრულება</span>
                        <p>${formatDateDMY(ad.expires_at)}</p>
                    </div>
                    <div class="detail-card">
                        <span>პრიორიტეტის დონე</span>
                        <p>${prioTranslations[ad.priority_level] || "სტანდარტული (დონე 0)"}</p>
                    </div>
                    <div class="detail-card">
                        <span>კამპანიის სტატუსი</span>
                        <p style="color: ${ad.is_active ? '#2e7d32' : '#c62828'}">${ad.is_active ? 'აქტიური' : 'არააქტიური'}</p>
                    </div>
                </div>

                <div class="section-title">სარეკლამო მასალა (კონტენტი)</div>
                <div class="grid-details" style="grid-template-columns: 1fr;">
                    <div class="detail-card">
                        <span>ბანერის სათაური</span>
                        <p>${ad.title || "N/A"}</p>
                    </div>
                    <div class="detail-card" style="margin-top: -5px;">
                        <span>მოკლე სარეკლამო აღწერა</span>
                        <p style="font-weight: normal; font-size: 13px; color: #475569;">${ad.text || "N/A"}</p>
                    </div>
                    <div class="detail-card" style="margin-top: -5px;">
                        <span>სამიზნე ბმული (Redirect URL)</span>
                        <p style="font-size: 12px; color: #4f46e5; word-break: break-all;">${ad.link || "N/A"}</p>
                    </div>
                </div>

                <div class="invoice-summary">
                    <span class="invoice-label">გადახდილი მომსახურების საფასური:</span>
                    <span class="invoice-price">₾${Number(ad.price).toFixed(2)} GEL</span>
                </div>

                <div class="terms-section">
                    <div class="terms-title">ოფიციალური პირობების შეჯამება:</div>
                    1. წინამდებარე დოკუმენტი ადასტურებს პლატფორმა "Teacher Hub"-ზე სარეკლამო მომსახურების გააქტიურების ფაქტს.<br>
                    2. მომსახურების დაწყების შემდგომ, გადახდილი თანხა უკან დაბრუნებას არ ექვემდებარება. დამკვეთის სურვილით ბანერის ვადაზე ადრე დეაქტივაციის შემთხვევაში, გადახდილი საფასური სრულად რჩება პლატფორმის განკარგულებაში.
                </div>

                <div class="signatures">
                    <div class="sig-block">
                        <div class="digital-stamp">
                            ✓ ავტორიზებული ელ-ხელმოწერა<br>
                            პროვაიდერი: TEACHER HUB GEORGIA<br>
                            ბმული: https://www.teacherhub.ge<br>
                            სისტემური ID: #${ad.id}
                        </div>
                        <div class="sig-line">სისტემის ადმინისტრატორი</div>
                    </div>
                    <div class="sig-block" style="justify-content: flex-end; height: 105px;">
                        <div class="sig-line">დამკვეთის წარმომადგენელი</div>
                    </div>
                </div>

                <div class="footer">
                    თიჩერ ჰაბი საქართველო © ${new Date().getFullYear()} - დოკუმენტი გენერირებულია ავტომატურად ბაზის ჩანაწერიდან
                </div>
                <script>
                    window.onload = function() { window.print(); window.close(); }
                </script>
            </body>
            </html>
        `);
        printWindow.document.close();
    };

    return (
        <div className="am-table-container">
            <table className="am-modern-table">
                <thead>
                <tr>
                    <th>დამკვეთი / მფლობელი</th>
                    <th>ბანერი</th>
                    <th>ბანერის აღწერილობა</th>
                    <th>დონე</th>
                    <th>შემოსავალი</th>
                    <th>პერიოდი</th>
                    <th>მოქმედება</th>
                </tr>
                </thead>
                <tbody>
                {ads.length > 0 ? ads.map((ad) => {
                    const hasImageError = imageErrors[ad.id] || !ad.image;

                    return (
                        <tr key={ad.id} className={`am-table-row ${!ad.is_active ? "am-row-deactivated" : ""}`}>
                            {/* დამკვეთის ბლოკი */}
                            <td className="am-td-owner">
                                <div className="am-owner-card">
                                    <div className="am-owner-header">
                                        <span className="am-owner-name">{ad.fullname}</span>
                                        <span className={`am-status-badge-modern ${ad.is_active ? 'active' : 'inactive'}`}>
                                                {ad.is_active ? 'აქტიური' : 'არააქტიური'}
                                            </span>
                                    </div>
                                    <div className="am-owner-id-badge">ID: {ad.person_id}</div>

                                    {(ad.phone || ad.email) && (
                                        <div className="am-owner-contacts-box">
                                            {ad.phone && (
                                                <a href={`tel:${ad.phone}`} className="am-contact-item">
                                                    <IoCallOutline className="contact-icon" /> {ad.phone}
                                                </a>
                                            )}
                                            {ad.email && (
                                                <a href={`mailto:${ad.email}`} className="am-contact-item" title={ad.email}>
                                                    <IoMailOutline className="contact-icon" /> {ad.email}
                                                </a>
                                            )}
                                        </div>
                                    )}
                                    <div className="am-database-id">ბაზის ID: <span>#{ad.id}</span></div>
                                </div>
                            </td>

                            {/* პრევიუ სურათი (Fallback-ით) */}
                            <td className="am-td-preview">
                                <div className="am-image-wrapper">
                                    {hasImageError ? (
                                        <div className="am-image-placeholder">
                                            <IoImageOutline className="placeholder-icon" />
                                            <span>No Image</span>
                                        </div>
                                    ) : (
                                        <img
                                            src={ad.image}
                                            alt="banner preview"
                                            className="am-banner-preview-img"
                                            onError={() => handleImageError(ad.id)}
                                        />
                                    )}
                                </div>
                            </td>

                            {/* დეტალები */}
                            <td className="am-td-details">
                                <div className="am-details-container">
                                    <h4 className="am-ad-title-text" title={ad.title}>{ad.title}</h4>
                                    <p className="am-ad-description-text" title={ad.text}>{ad.text}</p>
                                    <a href={ad.link} target="_blank" rel="noreferrer" className="am-interactive-link">
                                        <IoLinkOutline /> გადასასვლელი ლინკი
                                    </a>
                                </div>
                            </td>

                            {/* პრიორიტეტის დონე */}
                            <td className="am-td-level">
                                {renderPriorityBadge(ad.priority_level)}
                            </td>

                            {/* შემოსავალი */}
                            <td className="am-td-income">
                                <span className="am-income-amount">₾{ad.price ? Number(ad.price).toFixed(2) : "0.00"}</span>
                            </td>

                            {/* აქტივობის პერიოდი */}
                            <td className="am-td-dates">
                                <div className="am-dates-container">
                                    <div className="am-date-row">
                                        <span className="label">იწყება:</span>
                                        <span className="val date-start">{formatDateDMY(ad.started_at)}</span>
                                    </div>
                                    <div className="am-date-row">
                                        <span className="label">სრულდება:</span>
                                        <span className="val date-end">{formatDateDMY(ad.expires_at)}</span>
                                    </div>
                                </div>
                            </td>

                            {/* მოქმედებები */}
                            <td className="am-td-actions">
                                <div className="am-action-buttons-group">
                                    <button
                                        className="am-action-btn pdf"
                                        onClick={() => downloadAdPDF(ad)}
                                        title="ხელშეკრულების PDF"
                                    >
                                        <IoDownloadOutline size={18} />
                                    </button>

                                    <button
                                        className={`am-action-btn archive ${!ad.is_active ? 'disabled' : ''}`}
                                        disabled={loading || !ad.is_active}
                                        onClick={() => onDelete(ad.id)}
                                        title={ad.is_active ? "დეაქტივაცია" : "უკვე დეაქტივირებულია"}
                                    >
                                        <IoEyeOffOutline size={18} />
                                    </button>
                                </div>
                            </td>
                        </tr>
                    );
                }) : (
                    <tr>
                        <td colSpan="7" className="am-table-empty-state">
                            <div className="empty-message">
                                ამ კატეგორიის ({size}) აქტიური ბანერები ამჟამად არ არის დამატებული.
                            </div>
                        </td>
                    </tr>
                )}
                </tbody>
            </table>
        </div>
    );
}